var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"reports"},[_c('za-banner'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"linkus"},[_vm._v("联系我们")]),_c('div',{staticClass:"desc"},[_vm._v("公司：上海熠强网络科技有限公司")]),_c('div',{staticClass:"desc"},[_vm._v("邮箱：support@eaqiang.com")]),_c('div',{staticClass:"desc"},[_vm._v("地址：上海市闵行区宜山路1999号科技绿洲3期23号楼")])])
}]

export { render, staticRenderFns }